module.exports = __webpack_public_path__ + "media/img2.66871d2a.png";